/**
 * Display label for a Testdata Generator document type (`XMLInsights-SDD`
 * `REQ-TESTDATA-010`).
 *
 * The UI language owns the primary label; the selected test/document locale
 * only contributes a secondary label in parentheses when it is a different
 * term. React-free so it can be unit-tested with Node's built-in runner
 * (see `documentDisplayLabel.test.ts`).
 */
import type { DocType } from '../../types/testdata.types'

function sameTerm(a: string, b: string): boolean {
  // Case-insensitive, accent-sensitive: "Credit note" == "Credit Note",
  // but "Factuur" != "Facture".
  return a.localeCompare(b, undefined, { sensitivity: 'accent' }) === 0
}

export function documentDisplayLabel(uiLabel: string, localeLabel?: string | null): string {
  const ui = uiLabel.trim()
  const loc = (localeLabel ?? '').trim()
  if (!loc) return ui
  if (!ui) return loc
  return sameTerm(ui, loc) ? ui : `${ui} (${loc})`
}

export function documentDisplayLabels(
  uiLabels: Record<DocType, string>,
  localeLabels: Partial<Record<DocType, string>>,
): Record<DocType, string> {
  const out = {} as Record<DocType, string>
  for (const dt of Object.keys(uiLabels) as DocType[]) {
    out[dt] = documentDisplayLabel(uiLabels[dt], localeLabels[dt])
  }
  return out
}
